import BaseComponent from '../base-component/base-component'
import { checkEnterKey } from '../../utils/utils'
import { Nullable } from '../../types/common'

class Quantity extends BaseComponent {
  input: Nullable<HTMLInputElement>
  prevValue: string
  stockValue: string

  constructor() {
    super()

    this.input = this.querySelector('[data-quantity-input]')

    this.prevValue = this.value
    this.stockValue = this.dataset.stock || '0'
  }

  connectedCallback(): void {
    this.updateButtonsDisabled()

    this.input.addEventListener('keypress', this.handleKeydown)
    this.input.addEventListener('input', this.handleInput)
    this.input.addEventListener('blur', this.handleBlur)
  }

  disconnectedCallback(): void {
    this.input.removeEventListener('keypress', this.handleKeydown)
    this.input.removeEventListener('input', this.handleInput)
    this.input.removeEventListener('blur', this.handleBlur)
  }

  handleBlur = (event: KeyboardEvent): void => {
    if (this.input) {
      const target = event.target as HTMLInputElement
      const value = target.value || '0'

      this.input.value = value

      this.updateButtonsDisabled()

      this.prevValue = value
    }
  }

  handleKeydown = (event: KeyboardEvent): void => {
    if (this.input) {
      const isEnterKey = checkEnterKey(event.key || event.keyCode)

      if (isEnterKey) {
        event.preventDefault()

        this.input.blur()
      }
    }
  }

  handleInput = (event: InputEvent): void => {
    if (this.input) {
      const target = event.target as HTMLInputElement
      const value = target.value

      this.input.value = this.isMoreThanStock ? this.stockValue : value

      this.updateButtonsDisabled()

      this.prevValue = value
    }
  }

  inputChange(action: string): void {
    if (this.input) {
      if (action === 'minus') {
        this.input.stepDown()
      } else {
        this.input.stepUp()
      }

      if (+this.prevValue !== +this.value) {
        this.input.dispatchEvent(new Event('change', { bubbles: true }))
      }

      this.updateButtonsDisabled()
    }
  }

  updateButtonsDisabled(): void {
    this.updateButtonDisabled('minus', this.isLessThanMin)
    this.updateButtonDisabled('plus', this.isMoreThanStock)
  }

  setDisable(isDisabled: boolean): void {
    this.updateButtonDisabled('minus', isDisabled)
    this.updateButtonDisabled('plus', isDisabled)
  }

  updateButtonDisabled(btnType: string, isDisabled: boolean): void {
    const btn = this.querySelector(`quantity-btn[data-action="${btnType}"]`)

    if (btn) {
      btn.toggleAttribute('disabled', isDisabled)
    }
  }

  get value(): string {
    if (!this.input) {
      return '0'
    }

    return this.input.value
  }

  get isLessThanMin(): boolean {
    if (!this.input) {
      return false
    }

    return +this.value <= +this.input.min
  }

  get isMoreThanStock(): boolean {
    return +this.value >= +this.stockValue
  }
}

export default Quantity
